import React from 'react';
import { ExtendedContentContainer } from 'components/ExtendedContent/ExtendedContentContainer';
import NumberPicker from 'components/NumberPicker';

export const NumberPickerModalComponent = () => {
    return <ExtendedContentContainer>
        <NumberPicker />
    </ExtendedContentContainer>
};
